import { defineMessages } from 'react-intl';

export default defineMessages({
  sectionTitle: {
    id: 'fastCover.stepOverseasMedical.sectionTitle',
    defaultMessage:
      'Section 5 - Overseas Emergency Medical or Overseas Emergency Dental Expenses',
  },
  yes: {
    id: 'fastCover.stepOverseasMedical.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.stepOverseasMedical.no',
    defaultMessage: 'No',
  },
  areYouClaimingForOverseasEmergencyMedicalOrDentalExpenses: {
    id:
      'fastCover.stepOverseasMedical.areYouClaimingForOverseasEmergencyMedicalOrDentalExpenses',
    defaultMessage:
      'Are you claiming for Overseas Emergency Medical or Dental Expenses?',
  },
  areYouClaimingForOverseas247: {
    id: 'fastCover.stepOverseasMedical.areYouClaimingForOverseas247',
    defaultMessage:
      'Are you claiming for Overseas 24/7 Emergency Medical Assistance?',
  },
  areYouClaimingForEmergencyMedicalAndHospitalExpenses: {
    id: 'fastCover.stepOverseasMedical.areYouClaimingForEmergencyMedicalAndHospitalExpenses',
    defaultMessage:
      'Are you claiming for Overseas Emergency Medical & Hospital Expenses?',
  },
  areYouClaimingForEmergencyDental: {
    id: 'fastCover.stepOverseasMedical.areYouClaimingForEmergencyDental',
    defaultMessage: 'Are you claiming for Overseas Emergency Dental?',
  },
  areYouClaimingForEmergencyEvacuation: {
    id: 'fastCover.stepOverseasMedical.areYouClaimingForEmergencyEvacuation',
    defaultMessage: 'Are you claiming for Overseas Emergency Evacuation?',
  },
  areYouClaimingForHospitalCashPayment: {
    id: 'fastCover.stepOverseasMedical.areYouClaimingForHospitalCashPayment',
    defaultMessage: 'Are you claiming for Overseas Hospital Cash Payment?',
  },
  areYouClaimingForAccidentalDeath: {
    id: 'fastCover.stepOverseasMedical.areYouClaimingForAccidentalDeath',
    defaultMessage: 'Are you claiming for Accidental Death?',
  },
  areYouClaimingForPermanentDisability: {
    id: 'fastCover.stepOverseasMedical.areYouClaimingForPermanentDisability',
    defaultMessage: 'Are you claiming for Permanent Disability?',
  },
  areYouClaimingForLossOfIncome: {
    id: 'fastCover.stepOverseasMedical.areYouClaimingForLossOfIncome',
    defaultMessage:
      'Are you claiming for Loss of Income?',
  },
  toAssistYourClaim: {
    id: 'fastCover.stepOverseasMedical.toAssistYourClaim',
    defaultMessage: 'To assist your claim:',
  },
  toAssistYourClaimDetail1: {
    id: 'fastCover.stepOverseasMedical.toAssistYourClaim',
    defaultMessage:
      'We may need the below documents, please provide those that are applicable.',
  },
  toAssistYourClaimDetail2: {
    id: 'fastCover.stepOverseasMedical.toAssistYourClaim',
    defaultMessage: 'We may contact you to request further documentation.',
  },
  document: {
    id: 'fastCover.stepOverseasMedical.document',
    defaultMessage: 'Documents',
  },
  document1: {
    id: 'fastCover.stepOverseasMedical.document1',
    defaultMessage:
      'A copy of your Overseas Hospital Admission and Discharge paperwork.',
  },
  document2: {
    id: 'fastCover.stepOverseasMedical.document2',
    defaultMessage:
      'Medical reports from the patients Overseas Treating Doctor which confirm the diagnosis and if claiming for loss of income, the period of disablement.',
  },
  document3: {
    id: 'fastCover.stepOverseasMedical.document3',
    defaultMessage:
      'Itemised invoices for overseas medical and/or dental expenses claimed – including details of the diagnosis of the medical condition.',
  },
  document4: {
    id: 'fastCover.stepOverseasMedical.document4',
    defaultMessage:
      'Receipts for pharmacy expenses and copy of any prescription where possible.',
  },
  document5: {
    id: 'fastCover.stepOverseasMedical.document5',
    defaultMessage:
      'Complete and sign the Medical Authority in Section 11 (please note that this should be completed by the person whose illness or injury resulted in this claim or the Executor of the Estate in the event of a death).',
  },
  document6: {
    id: 'fastCover.stepOverseasMedical.document6',
    defaultMessage:
      'Please have the patient’s usual treating Doctor or Specialist in Australia complete the Medical Certificate in Section 12.',
  },
  document7: {
    id: 'fastCover.stepOverseasMedical.document7',
    defaultMessage:
      'If claiming loss of income, a medical certificate from the patients treating Doctor or Specialist in Australia confirming the diagnosis and ongoing nature of the disablement, including period unable to work.',
  },
  document8: {
    id: 'fastCover.stepOverseasMedical.document8',
    defaultMessage:
      'If the claim is as a result of someone’s death, you will need to provide a copy of the death certificate which states the cause of death.',
  },
  document9: {
    id: 'fastCover.stepOverseasMedical.document9',
    defaultMessage:
      'A medical certificate from your treating doctor at the time of injury confirming diagnosis and the disablement.',
  },
  document10: {
    id: 'fastCover.stepOverseasMedical.document10',
    defaultMessage:
      'A medical certificate from your usual Doctor confirming the diagnosis and ongoing nature of your disablement including period unable to return to work.',
  },
  document11: {
    id: 'fastCover.stepOverseasMedical.document11',
    defaultMessage:
      'A letter from your employer stating the date you were due to return to work. (for loss of income claims only)',
  },
  document12: {
    id: 'fastCover.stepOverseasMedical.document12',
    defaultMessage:
      'Written evidence of your lost income (last two payslips prior to injury, tax return from last financial year etc.).',
  },
  document13: {
    id: 'fastCover.stepOverseasMedical.document13',
    defaultMessage:
      'A medical certificate from your treating doctor at the time of injury confirming diagnosis of the injury',
  },
  document14: {
    id: 'fastCover.stepOverseasMedical.document14',
    defaultMessage:
      'A medical certificate from your usual Doctor confirming the diagnosis',
  },
  document15: {
    id: 'fastCover.stepOverseasMedical.document15',
    defaultMessage:
      'Written confirmation of the disappearance, sinking or incident report for a cash of the insureds transport provider',
  },
  document16: {
    id: 'fastCover.stepOverseasMedical.document16',
    defaultMessage:
      'Written confirmation that the insured has been presumed dead and that their body has not been found within 12 months',
  },
  document17: {
    id: 'fastCover.stepOverseasMedical.document17',
    defaultMessage: 'A copy of the insureds death certificate',
  },
  provideExplanation: {
    id: 'fastCover.stepOverseasMedical.provideExplanation',
    defaultMessage:
      'If you cannot provide any of the above documents, please provide an explanation why you are unable to.',
  },
  patientName: {
    id: 'fastCover.stepOverseasMedical.patientName',
    defaultMessage: "Patient's name",
  },
  relationshipToYou: {
    id: 'fastCover.stepOverseasMedical.relationshipToYou',
    defaultMessage: 'Relationship to you',
  },
  patientDateOfBirth: {
    id: 'fastCover.stepOverseasMedical.patientDateOfBirth',
    defaultMessage: 'Patients Date of Birth',
  },
  medicareNumber: {
    id: 'fastCover.stepOverseasMedical.medicareNumber',
    defaultMessage: 'Medicare number',
  },
  whatIsYourInjuryOrIllness: {
    id: 'fastCover.stepOverseasMedical.whatIsYourInjuryOrIllness',
    defaultMessage: 'What was the injury or illness?',
  },
  didThisOccurWhilstEngagingInSnowSportActivity: {
    id: 'fastCover.stepOverseasMedical.didThisOccurWhilstEngagingInSnowSportActivity',
    defaultMessage: 'Did this occur whilst engaging in Snow Sport activity?',
  },
  wasTheInufredIllTravallerAnInpatient: {
    id: 'fastCover.stepOverseasMedical.wasTheInufredIllTravallerAnInpatient',
    defaultMessage: 'Was the injured/ill traveller an inpatient?',
  },
  dateOfAdmission: {
    id: 'fastCover.stepOverseasMedical.dateOfAdmission',
    defaultMessage: 'Date of admission',
  },
  timeOfAdmission: {
    id: 'fastCover.stepOverseasMedical.timeOfAdmission',
    defaultMessage: 'Time of admission',
  },
  dateOfDischarge: {
    id: 'fastCover.stepOverseasMedical.dateOfDischarge',
    defaultMessage: 'Date of discharge',
  },
  timeOfDischarge: {
    id: 'fastCover.stepOverseasMedical.timeOfDischarge',
    defaultMessage: 'Time of discharge',
  },
  nameOfPractitionerDentistHospital: {
    id: 'fastCover.stepOverseasMedical.nameOfPractitionerDentistHospital',
    defaultMessage:
      'Name of the overseas medical practitioner, dentist and/or hospital you visited',
  },
  contactEmergencyAssistance: {
    id: 'fastCover.stepOverseasMedical.contactEmergencyAssistance',
    defaultMessage: 'Did you contact our Emergency Assistance team?',
  },
  assistanceCaseReferenceNumber: {
    id: 'fastCover.stepOverseasMedical.assistanceCaseReferenceNumber',
    defaultMessage: 'Assistance Case Reference Number',
  },
  dateOfFirstMedicalConsultation: {
    id: 'fastCover.stepOverseasMedical.dateOfFirstMedicalConsultation',
    defaultMessage: 'Date of first medical consultation',
  },
  hasInjuredOrIllTravellerPreviously: {
    id: 'fastCover.stepOverseasMedical.hasInjuredOrIllTravellerPreviously',
    defaultMessage:
      'Has the injured or ill traveller previously suffered from the medical or dental condition which led to this claim?',
  },
  mayNeedInjuredIllPerson: {
    id: 'fastCover.stepOverseasMedical.mayNeedInjuredIllPerson',
    defaultMessage:
      'We may need the injured/ill person to complete Section 12, Medical Authority and their usual GP/Specialist to complete Section 13 - Medical Certificate)',
  },
  medicalExpenses: {
    id: 'fastCover.stepOverseasMedical.medicalExpenses',
    defaultMessage: 'Medical Expenses',
  },
  medicalExpense: {
    id: 'fastCover.stepOverseasMedical.medicalExpense',
    defaultMessage: 'Medical Expense',
  },
  dateOfTreatment: {
    id: 'fastCover.stepOverseasMedical.dateOfTreatment',
    defaultMessage: 'Date of treatment',
  },
  nameOfDoctorOrProvider: {
    id: 'fastCover.stepOverseasMedical.nameOfDoctorOrProvider',
    defaultMessage: 'Name of Doctor/Dentist/Pharmacy/Hospital or Provider',
  },
  treatmentReceived: {
    id: 'fastCover.stepOverseasMedical.treatmentReceived',
    defaultMessage: 'Treatment received',
  },
  amountCharged: {
    id: 'fastCover.stepOverseasMedical.amountCharged',
    defaultMessage: 'Amount charged',
  },
  currency: {
    id: 'fastCover.stepOverseasMedical.currency',
    defaultMessage: 'Currency',
  },
  didYouPayThisAmount: {
    id: 'fastCover.stepOverseasMedical.didYouPayThisAmount',
    defaultMessage: 'Did you pay this amount?',
  },
  refundAmountFromHealthFund: {
    id: 'fastCover.stepOverseasMedical.refundAmountFromHealthFund',
    defaultMessage: 'Refund amount from health fund',
  },
  amountClaimed: {
    id: 'fastCover.stepOverseasMedical.amountClaimed',
    defaultMessage: 'Amount claimed',
  },
  addMedicalExpense: {
    id: 'fastCover.stepOverseasMedical.addMedicalExpense',
    defaultMessage: 'Add Medical expense',
  },
  policyMessage: {
    id: 'fastCover.stepOverseasMedical.policyMessage',
    defaultMessage:
      'At any point before you purchased your policy and before your departure were you or the person whose illnes or injury resulted in this claim:',
  },
  awareOfAnyMedicalConditions: {
    id: 'fastCover.stepOverseasMedical.awareOfAnyMedicalConditions',
    defaultMessage:
      '1. Aware of any medical conditions which could reasonably be expected to give rise to a claim?',
  },
  underInvestigation: {
    id: 'fastCover.stepOverseasMedical.underInvestigation',
    defaultMessage:
      '2. Under investigation for an ongoing medical condition by a GP or Specialist? (including undergoing tests whether or not a diagnosis had been made)',
  },
  haveMedicalConditionOrComplication: {
    id: 'fastCover.stepOverseasMedical.haveMedicalConditionOrComplication',
    defaultMessage:
      '3. Have any medical condition or complication directly or indirectly related to the medical condition giving rise to this claim?',
  },
  giveATerminalPrognosis: {
    id: 'fastCover.stepOverseasMedical.giveATerminalPrognosis',
    defaultMessage:
      '4. Been given a terminal prognosis for their medical condition?',
  },
  travellingAgainst: {
    id: 'fastCover.stepOverseasMedical.travellingAgainst',
    defaultMessage:
      '5. Travelling against the advice of a medical practitioner?',
  },
  previousMedicalConditionDetails: {
    id: 'fastCover.stepOverseasMedical.previousMedicalConditionDetails',
    defaultMessage: 'Previous medical condition details',
  },
  isRequired: {
    id: 'fastCover.stepOverseasMedical.isRequired',
    defaultMessage: "'{defaultMessage}' is required",
  },
  medicalExpenseRequired: {
    id: 'fastCover.stepOverseasMedical.medicalExpenseRequired',
    defaultMessage: 'Medical Expenses table fields are required fields.',
  },
  plannedReturnToWorkDate: {
    id: 'fastCover.stepOverseasMedical.plannedReturnToWorkDate',
    defaultMessage: 'Planned return to work date',
  },
  actualReturnToWorkDate: {
    id: 'fastCover.stepOverseasMedical.actualReturnToWorkDate',
    defaultMessage: 'Actual return to work date',
  },
  incomeLost: {
    id: 'fastCover.stepOverseasMedical.incomeLost',
    defaultMessage: 'Income lost',
  },
  insuredName: {
    id: 'fastCover.stepOverseasMedical.insuredName',
    defaultMessage: "Insured's name",
  },
  insuredDateOfDeath: {
    id: 'fastCover.stepOverseasMedical.insuredDateOfDeath',
    defaultMessage: "Insured's Date of Death",
  },
  whatWasTheInjury: {
    id: 'fastCover.stepOverseasMedical.whatWasTheInjury',
    defaultMessage: 'What was the injury?',
  },
  other1: {
    id: 'fastCover.stepOverseasMedical.other1',
    defaultMessage: 'Medical report from your overseas doctor which confirms the diagnosis',
  },
  other2: {
    id: 'fastCover.stepOverseasMedical.other2',
    defaultMessage: 'Discharge summary and admission paperwork (if you were hospitalised overseas)',
  },
  other3: {
    id: 'fastCover.stepOverseasMedical.other3',
    defaultMessage: 'Itemised invoices for overseas medical, pharmacy and/or dental expenses claimed',
  },
  other4: {
    id: 'fastCover.stepOverseasMedical.other4',
    defaultMessage: 'Any other receipt/proof of payment for the expenses incurred relating to this event happening',
  },
  other5: {
    id: 'fastCover.stepOverseasMedical.other5',
    defaultMessage: 'If claiming loss of income due to injury, a medical certificate from the insured’s treating doctor or specialist in Australia confirming the diagnosis, period of inability to work and the ongoing nature of the disablement',
  },
  medicalExpenseWithIdx: {
    id: 'fastCover.stepOverseasMedical.medicalExpenseWithIdx',
    defaultMessage: 'Medical Expense {idx}',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepOverseasMedical/messages.js